// extracted by mini-css-extract-plugin
export default {"shake-effect":"NotificationContainer_shake-effect__ZpcdX","leftRightShake":"NotificationContainer_leftRightShake__Cir5S"};